var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadImageSentiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 7 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4618_58506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1C4.88261 1 5.00979 1.05268 5.10355 1.14645C5.19732 1.24021 5.25 1.36739 5.25 1.5V4.5C5.25 4.63261 5.19732 4.75979 5.10355 4.85355C5.00979 4.94732 4.88261 5 4.75 5H4.25V5.5C4.25 5.63261 4.19732 5.75979 4.10355 5.85355C4.00979 5.94732 3.88261 6 3.75 6H1.25C1.11739 6 0.990215 5.94732 0.896447 5.85355C0.802678 5.75979 0.75 5.63261 0.75 5.5V2.5C0.75 2.36739 0.802678 2.24021 0.896447 2.14645C0.990215 2.05268 1.11739 2 1.25 2H1.75V1.5C1.75 1.36739 1.80268 1.24021 1.89645 1.14645C1.99021 1.05268 2.11739 1 2.25 1H4.75ZM3.75 2.5H1.25V5.5H3.75V2.5ZM2.5 4.25C2.5663 4.25 2.62989 4.27634 2.67678 4.32322C2.72366 4.37011 2.75 4.4337 2.75 4.5C2.75 4.5663 2.72366 4.62989 2.67678 4.67678C2.62989 4.72366 2.5663 4.75 2.5 4.75H2C1.9337 4.75 1.87011 4.72366 1.82322 4.67678C1.77634 4.62989 1.75 4.5663 1.75 4.5C1.75 4.4337 1.77634 4.37011 1.82322 4.32322C1.87011 4.27634 1.9337 4.25 2 4.25H2.5ZM4.75 1.5H2.25V2H3.75C3.88261 2 4.00979 2.05268 4.10355 2.14645C4.19732 2.24021 4.25 2.36739 4.25 2.5V4.5H4.75V1.5ZM3 3.25C3.06372 3.25007 3.12501 3.27447 3.17134 3.31821C3.21768 3.36195 3.24556 3.42174 3.24929 3.48535C3.25303 3.54896 3.23233 3.61159 3.19143 3.66046C3.15054 3.70932 3.09252 3.74072 3.02925 3.74825L3 3.75H2C1.93628 3.74993 1.87499 3.72553 1.82866 3.68179C1.78232 3.63805 1.75444 3.57826 1.75071 3.51465C1.74697 3.45104 1.76767 3.38841 1.80857 3.33954C1.84946 3.29068 1.90748 3.25928 1.97075 3.25175L2 3.25H3Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4618_58506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImageSentiment);
export default __webpack_public_path__ + "static/media/downloadImageSentiment.8bd7e541bd8c066714c82f4cac8658a0.svg";
export { ForwardRef as ReactComponent };